import { IncomingHistoriesGQL } from '@schema';
import { QueryData } from '@shared/apollo/query-actions';
import { NamingConfig } from '@shared/naming/naming-config';

export type IncomingHistory = Omit<
  QueryData<IncomingHistoriesGQL, ['irtIncomingTransmissionHistory']>[number],
  '__typename'
>;

export const IncomingHistoryNaming = NamingConfig<IncomingHistory>({
  key: 'IncomingHistory',
  modelName: { '=1': $localize`Incoming History`, other: $localize`Incoming Histories` },
  fieldNames: {
    id: $localize`ID`,
    integrationConfigId: $localize`Integration Config ID`,
    integrationConfigName: $localize`Integration Config`,
    integrationConfigUrl: $localize`URL`,
    integrationConfigHttpMethod: $localize`HTTP Method`,
    internalEventName: $localize`Event Type`,
    templateName: $localize`Template`,
    errorMessage: $localize`Error Message`,
    status: $localize`Status`,
    createdUtc: $localize`Created At`,
    deliveryMode: $localize`Delivery Mode`,
    jobRunId: $localize`Job Run`,
  },
});
